// ─── INKY TEXTILES THEME JS ───────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {

  // ─── FAQ ACCORDION ───
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ─── MOBILE NAV ───
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const navLinks = document.querySelector('.nav-links');
  if (mobileBtn && navLinks) {
    mobileBtn.addEventListener('click', () => {
      const isOpen = navLinks.classList.contains('mobile-open');
      navLinks.classList.toggle('mobile-open');
      mobileBtn.setAttribute('aria-expanded', String(!isOpen));
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
    // Close nav when a link is tapped on mobile
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('mobile-open');
        mobileBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // ─── ACTIVE NAV LINK ───
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(link => {
    const href = link.getAttribute('href');
    if (href && href !== '/' && currentPath.startsWith(href)) {
      link.classList.add('active');
    } else if (href === currentPath) {
      link.classList.add('active');
    }
  });

  // ─── PRODUCT GALLERY ───
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-main-img img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg && thumb.querySelector('img')) {
        mainImg.src = thumb.querySelector('img').src;
      }
    });
  });

  // ─── QUANTITY BUTTONS (data-action fallback for non-inline-onclick buttons) ───
  document.querySelectorAll('.qty-btn[data-action]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('.qty-ctrl');
      const input = wrap ? wrap.querySelector('.qty-val') : null;
      if (!input) return;
      const delta = btn.dataset.action === 'minus' ? -1 : 1;
      const min = parseInt(input.min || '1');
      const newVal = Math.max(min, parseInt(input.value || '1') + delta);
      input.value = newVal;
    });
  });

  // ─── FILTER BUTTONS ───
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ─── SCROLL ANIMATIONS ───
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.card, .step-card, .trust-item, .testimonial-card, .icp-card, .product-card').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .5s ease, transform .5s ease';
      observer.observe(el);
    });
  }

});
